import React, { useEffect } from 'react'
import { useDrag } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'

import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons'
import { styled } from '@mui/material'
import { GridRenderCellParams, useGridApiContext } from '@mui/x-data-grid-premium'

import { Icon } from '../../Icon/Icon'
import { GridTableDragItem, GridTableDragType } from '../models/GridTableDragType'
import { useDragDropGridContext } from './DragDropGridContext'

export type DraggableGridCellProps = GridRenderCellParams & {
  //
}


// TODO: based on the row definitions, might have to hide the drag handle
export const DraggableGridCell: React.FC<DraggableGridCellProps> = (props) => {
  const { id, row } = props
  const apiRef = useGridApiContext()
  const { setDraggingRows } = useDragDropGridContext()

  // TODO: why does the order of the selected rows changed when dropped based on the server's response?
  const [{ isDragging }, dragRef, preview] = useDrag({
    type: row.dragType ?? GridTableDragType.ROW,
    item: () => {
      const selectedRows = apiRef.current.getSelectedRows()
      let dragItem: GridTableDragItem = { id, rows: [row], type: row.dragType ?? GridTableDragType.ROW }

      const selectedRowsData = [...selectedRows.values()]

      if (!selectedRowsData.find((r) => r.id === id)) {
        selectedRowsData.push(row)
        apiRef.current.selectRows([id], true)
      }

      setDraggingRows([...selectedRowsData.map(item => item.id)])
      dragItem = { id, rows: selectedRowsData, type: row.dragType ?? GridTableDragType.ROW }

      return dragItem
    },
    collect: (monitor) => {
      return {
        isDragging: monitor.isDragging(),
      }
    },
  }, [apiRef, row, id, setDraggingRows])

  useEffect(() => {
    if (!isDragging) {
      setDraggingRows([])
    }
  }, [isDragging, setDraggingRows])

  // The drag preview is handle by CustomDragLayer, so we need to hide the default drag preview
  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true })
  }, [preview, id])

  return row.isDraggable ? (
    <StyledCell ref={dragRef} $isDragging={isDragging}>
      <StyledGripHandle icon={faGripDotsVertical} />
    </StyledCell>
  ) : null
}

const StyledCell = styled('div', { shouldForwardProp: (prop) => prop !== '$isDragging' }) <{ $isDragging: boolean }>`
  color: ${({ theme }) => theme.palette.text.primary};
  background-color: transparent;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  opacity: ${({ $isDragging }) => ($isDragging ? 0.5 : 1)};
`

const StyledGripHandle = styled(Icon)`
  font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  color: ${({ theme }) => theme.palette.text.secondary};
`
